var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.331,
    height: 36.166,
    viewBox: "0 0 35.331 36.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item_5",
    "data-name": "Item 5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Avatar",
    d: "M6.159,12.329A4.2,4.2,0,0,1,7.994,8.978C8.833,3.594,12.366,0,17.666,0S26.5,3.594,27.339,8.978a4.2,4.2,0,0,1,1.835,3.351A4.388,4.388,0,0,1,26.888,16a9.834,9.834,0,0,1-4.29,5.736v.791c6.623.973,10.909,4.1,12.579,9.357a3.288,3.288,0,0,1-3.134,4.283H3.289A3.288,3.288,0,0,1,.155,31.883c1.671-5.258,5.956-8.384,12.579-9.357v-.791A9.834,9.834,0,0,1,8.444,16,4.388,4.388,0,0,1,6.159,12.329Z",
    transform: "translate(0)",
    fill: "#e30613"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.992925d96ad92aede970fadc356667db.svg";
export { ForwardRef as ReactComponent };